var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { makeObservable, observable, runInAction } from 'mobx';
import { Addon, AddonList as AddonListModel } from '@data/models';
import { AddonsService } from '@data/api/services/addons';
import MultilangText from '@data/models/MultilangText';
import { persistentPropertyStorage } from '../PersistentPropertyStorage';
export default class Addons {
    constructor() {
        Object.defineProperty(this, "isFetching", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "model", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "search", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (_a) => __awaiter(this, [_a], void 0, function* ({ accommodations, checkin, checkout, language, propertyId, }) {
                runInAction(() => {
                    this.model = null;
                });
                runInAction(() => {
                    this.isFetching = true;
                });
                const result = !(propertyId && checkin && checkout)
                    ? null
                    : yield AddonsService.search({
                        accommodations,
                        checkin,
                        checkout,
                        language,
                        propertyId,
                    });
                runInAction(() => {
                    this.isFetching = false;
                    this.model = result;
                });
                return result;
            })
        });
        makeObservable(this);
    }
    get storageKey() {
        return 'addons';
    }
    load() {
        var _a;
        const loadedData = persistentPropertyStorage.getItem(this.storageKey);
        if (loadedData) {
            const parsedData = JSON.parse(loadedData);
            const model = new AddonListModel();
            (_a = parsedData === null || parsedData === void 0 ? void 0 : parsedData.model) === null || _a === void 0 ? void 0 : _a.items.forEach((item) => {
                const addon = new Addon();
                Object.assign(addon, item);
                addon.name = new MultilangText(addon.name);
                addon.description = new MultilangText(addon.description);
                model.items.push(addon);
            });
            this.model = model;
        }
    }
    save() {
        persistentPropertyStorage.setItem(this.storageKey, JSON.stringify(this));
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], Addons.prototype, "isFetching", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Addons.prototype, "model", void 0);
